export class EditEvent {
  name?: string;
  address?: string;
  phone?: string;
  email?: string;
  logoUrl?: string;
  coverUrl?: string;
  folderUrl?: string;
  ruleUrl?: string;
}
